<div class="pan-container" #panzoomContainer>
  <div class="noselect fade-in" #panzoomElement>
    <ng-content></ng-content>
  </div>
</div>
